<template>
  <div style="margin: 10px; height: 600px">
    <v-form direction="horizontal">
      <div style="text-align: left">
        <v-affix :offset-top="10">
          <v-button type="success" icon="save" @click.prevent="save()"
            >保存</v-button
          >
        </v-affix>
      </div>
      <v-form-item
        label="休假类型代码"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input
          v-model="options.xjlx_dm"
          placeholder="休假类型代码"
          v-bind:disabled="xjlxdm_dis"
        ></v-input>
      </v-form-item>
      <v-form-item
        label="休假类型名称"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
        required
      >
        <v-input v-model="options.xjlx_mc" placeholder="休假类型名称"></v-input>
      </v-form-item>
      <v-form-item
        label="总天数"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-input v-model="options.zs" placeholder="总天数"></v-input>
      </v-form-item>
      <v-form-item
        label="备注"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-input v-model="options.xjlx_ms" placeholder="备注"></v-input>
      </v-form-item>
      <v-form-item
        label="启用"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        has-feedback
      >
        <v-switch v-model="options.xy_bz"></v-switch>
      </v-form-item>
    </v-form>
  </div>
</template>

<script>
let options = {
  xjlx_dm: "",
  xjlx_mc: "",
  xjlx_ms: "",
  zs:"",
  xy_bz: true,
};
export default {
  data() {
    return {
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
      options,
      xjlxdm_dis: false,
    };
  },
  created() {
    if (this.$route.query.xjlx_dm) {
      this.init();
      this.xjlxdm_dis = true;
    }
  },
  methods: {
    init: function () {
      this.$axios
        .get("api/system/xjlx/get-xjlx-first?xjlx_dm=" + this.$route.query.xjlx_dm)
        .then((res) => {
          this.options = res.data;
          if (res.data.xy_bz == 1) {
            this.options.xy_bz = true;
          } else {
            this.options.xy_bz = false;
          }
        });
    },
    save() {
      if(!this.options.xjlx_dm){
        this.$message["error"]("请输入休假类型代码");
        return;
      }
      if(!this.options.xjlx_mc){
        this.$message["error"]("请输入休假名称");
        return;
      }
      if (this.options.xy_bz) {
        this.options.xy_bz = "1";
      } else {
        this.options.xy_bz = "0";
      }
      if (this.$route.query.xjlx_dm) {
        this.$axios
          .post("api/system/xjlx/update-xjlx-first", this.options)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message["success"](res.data.message);
              xadmin.close();
              xadmin.father_reload();
            } else {
              this.$message["error"](res.data.message);
            }
          });
      } else {
        this.$axios
          .post("api/system/xjlx/set-xjlx-first", this.options)
          .then((res) => {
            if (res.data.code == 200) {
              this.$message["success"](res.data.message);
              xadmin.close();
              xadmin.father_reload();
            } else {
              this.$message["error"](res.data.message);
            }
          });
      }
    },
    cancel: function () {
      xadmin.close();
    },
  },
};
</script>


<style>
</style>


// WEBPACK FOOTER //
// src/view/xtgl/jcsj/xjlxwhadd.vue